import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  showUpdate,
  limpa,
  showIntervalo,
  getList,
  create,
  setPaginaAtual,
  sincronizarConfiguracaoCompleta,
  getTabelasTrocaPlano,
  excluirTabelasTroca,
} from './planoActions';
import { getListInterval, update, getListTodosPlanosPorAnel } from '../intervalo/intervaloActions';
import SPButton from '../common/form/spButton';
import ButtonTooltip from '../common/form/buttonTooltip';
import PremiumTableShell from '../common/grid/premiumTableShell';

import ReactTableGT2A from '../common/grid/gridReactTable';
import '../common/grid/grid.css';
import ActionConfirmModal from '../common/components/actionConfirmModal';
import ProcessingOverlay from '../common/components/processingOverlay';
import { toastr } from 'react-redux-toastr';

import PermissaoUsuario from '../auth/permissao';
import { getConfig } from '../configuracao/configLocal';
import { lerAneis } from '../controlador/controladorActions';
import If from '../common/operator/if';
import html2canvas from 'html2canvas';

class PlanoList extends Component {
  constructor(props) {
    super(props);

    this.intervalGetList = 0;
    this.componentRef = React.createRef();

    this.limparPlano = this.limparPlano.bind(this);
    this.alterarPlano = this.alterarPlano.bind(this);
    this.configurarPlano = this.configurarPlano.bind(this);
    this.lerPlanoControlador = this.lerPlanoControlador.bind(this);
    this.salvarPlanoDB = this.salvarPlanoDB.bind(this);
    this.lerPlanoSistema = this.lerPlanoSistema.bind(this);
    this.confirmarExclusaoPlano = this.confirmarExclusaoPlano.bind(this);
    this.cancelarExclusaoPlano = this.cancelarExclusaoPlano.bind(this);
    this.confirmarSalvarPlanoDB = this.confirmarSalvarPlanoDB.bind(this);
    this.cancelarSalvarPlanoDB = this.cancelarSalvarPlanoDB.bind(this);

    this.modOperacaoDesc = [
      'Isolado/Normal',
      'Isolado/Atuado',
      'Isolado Atuado com Sequência Lógica',
      'Sincronizado/Normal',
      'Sincronizado/Atuado',
      'Sincronizado Atuado com Sequência Lógica',
      'Adaptativo Local',
      'Adaptativo Sincronizado',
    ];

    this.state = {
      planoList: [],
      intervaloList: [],
      salvarDB: false,
      confirmExclusao: null,
      confirmSalvarConfig: null,
      processingExclusao: false,
      processingExclusaoMessage: '',
      processingGeral: false,
      processingMessage: '',
      processingDetail: '',
    };
  }

  startProcessing(message, detail = '') {
    this.setState({
      processingGeral: true,
      processingMessage: message,
      processingDetail: detail,
    });
  }

  stopProcessing(extraState = {}) {
    this.setState({
      processingGeral: false,
      processingMessage: '',
      processingDetail: '',
      ...extraState,
    });
  }

  buildConfiguracoesPorAnel() {
    if (!this.state.planoList || this.state.planoList.length === 0) {
      return null;
    }

    const planosAgrupadosPorAnel = this.state.planoList.reduce(
      (acc, plano) => {
        const anelId = plano.controlador_id;
        if (!anelId) {
          console.error('Plano sem controlador_id válido encontrado:', plano);
          toastr.error('Erro de Dados', `Plano ${plano.id} (Anel ${plano.anel}) está sem ID de controlador.`);
          acc.hasError = true;
          return acc;
        }
        if (!acc[anelId]) {
          acc[anelId] = [];
        }
        acc[anelId].push(plano);
        return acc;
      },
      { hasError: false },
    );

    if (planosAgrupadosPorAnel.hasError) {
      toastr.error('Erro', 'Alguns planos não puderam ser agrupados. Verifique o console.');
      return null;
    }
    delete planosAgrupadosPorAnel.hasError;

    const configuracoesPorAnel = Object.keys(planosAgrupadosPorAnel).map(anelId => {
      const planosDoAnel = planosAgrupadosPorAnel[anelId];
      return {
        controlador_id: anelId.toString(),
        planos: planosDoAnel.map(plano => ({
          plano_id_controlador: plano.id,
          descricao: plano.descricao,
          status: plano.status === undefined ? 1 : plano.status,
          modo_operacao_id: plano.modo_operacao_id,
          numero_intervalo: plano.numero_intervalo,
          ciclo_maximo: plano.ciclo_maximo,
          defasagem: plano.defasagem,
          atuado_var: plano.atuador_var,
          intervalos: plano.intervalos,
        })),
      };
    });

    if (configuracoesPorAnel.length === 0) {
      toastr.warning('Atenção', 'Não foi possível formatar nenhuma configuração para salvar.');
      return null;
    }

    return configuracoesPorAnel;
  }

  salvarPlanoDB() {
    const configuracoesPorAnel = this.buildConfiguracoesPorAnel();
    if (!configuracoesPorAnel) {
      if (!this.state.planoList || this.state.planoList.length === 0) {
        toastr.warning('Atenção', 'Não há dados de planos lidos do controlador para salvar.');
      }
      return;
    }

    this.setState({
      confirmSalvarConfig: {
        configuracoesPorAnel,
        totalAneis: configuracoesPorAnel.length,
        totalPlanos: this.state.planoList.length,
      },
    });
  }

  cancelarSalvarPlanoDB() {
    this.setState({ confirmSalvarConfig: null });
  }

  async confirmarSalvarPlanoDB() {
    const { confirmSalvarConfig } = this.state;
    if (!confirmSalvarConfig) return;

    const { configuracoesPorAnel, totalAneis } = confirmSalvarConfig;
    this.setState({ confirmSalvarConfig: null });
    this.startProcessing(
      `Sincronizando ${totalAneis} anel(éis)...`,
      'Aguarde, este processo pode levar algum tempo.',
    );

    try {
      const canvas = await html2canvas(this.componentRef.current);
      const image = canvas.toDataURL('png');

      const configuracoesPorAnelComImagem = configuracoesPorAnel.map(config => ({
        ...config,
        imageLog: image,
      }));

      await this.props.sincronizarConfiguracaoCompleta(configuracoesPorAnelComImagem);
      this.lerPlanoSistema();
    } catch (error) {
      console.error('Falha geral no processo de sincronização:', error);
    } finally {
      this.stopProcessing();
    }
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  lerPlanoSistema() {
    this.setState({ planoList: [], salvarDB: false });
    this.props.getList();
  }

  async lerPlanoControlador() {
    this.startProcessing('Carregando informações dos anéis...', 'Comunicando com o controlador.');
    this.setState({ planoList: [], salvarDB: false });
    const numCont = getConfig('numCont');
    const grupo = getConfig('grupo');
    let todosOsPlanosColetados = [];
    const resumoLeitura = { lidos: [], vazios: [], erros: [] };

    try {
      const respostaAneis = await this.props.lerAneis(numCont, grupo, true);
      const aneis =
        (respostaAneis && respostaAneis.data) ||
        (respostaAneis && respostaAneis.payload && respostaAneis.payload.data) ||
        this.props.aneis ||
        [];

      if (!aneis || aneis.length === 0) {
        toastr.error('Erro', 'Nenhum anel encontrado para este controlador.');
        this.stopProcessing();
        return;
      }
      for (const anelInfo of aneis) {
        this.setState({
          processingMessage: `Lendo todos os planos do Anel ${anelInfo.anel}...`,
          processingDetail: 'Aguarde, esse processo pode levar algum tempo.',
        });
        try {
          const resultadoAnel = await this.props.getListTodosPlanosPorAnel(anelInfo.anel, numCont, grupo);
          const respostaAnel =
            (resultadoAnel && resultadoAnel.payload && resultadoAnel.payload.data) ||
            (resultadoAnel && resultadoAnel.data) ||
            null;

          if (respostaAnel && respostaAnel.success) {
            const planosDoAnel = respostaAnel.data;
            if (planosDoAnel.length > 0) {
              resumoLeitura.lidos.push(anelInfo.anel);
              const planosFormatadosParaLista = planosDoAnel.map(planoBackend => ({
                anel: planoBackend.anel,
                controlador_id: planoBackend.controlador_id,
                id: planoBackend.plano_id_controlador,
                descricao: planoBackend.descricao,
                status: 1,
                modo_operacao_id: planoBackend.modo_operacao_id,
                modo_operacao_desc: this.modOperacaoDesc[planoBackend.modo_operacao_id],
                numero_intervalo: planoBackend.numero_intervalo,
                ciclo_maximo: planoBackend.ciclo_maximo,
                defasagem: planoBackend.defasagem,
                atuador_var: planoBackend.atuado_var,
                intervalos: planoBackend.intervalos,
                tempo_vermelho_min: planoBackend.tempo_vermelho_min_controlador,
                tempo_amarelo_min: planoBackend.tempo_amarelo_min_controlador,
                tempo_verde_min: planoBackend.tempo_verde_min_controlador,
                fase_conflitante: planoBackend.fases_conflitantes_controlador,
              }));
              todosOsPlanosColetados = [...todosOsPlanosColetados, ...planosFormatadosParaLista];
              this.setState({ planoList: [...todosOsPlanosColetados], salvarDB: true });
            } else {
              resumoLeitura.vazios.push(anelInfo.anel);
            }
          } else {
            const errorMsg =
              (resultadoAnel &&
                resultadoAnel.response &&
                resultadoAnel.response.data &&
                resultadoAnel.response.data.errors &&
                resultadoAnel.response.data.errors[0]) ||
              (resultadoAnel &&
                resultadoAnel.payload &&
                resultadoAnel.payload.response &&
                resultadoAnel.payload.response.data.errors &&
                resultadoAnel.payload.response.data.errors[0]) ||
              `Erro ao ler planos do Anel ${anelInfo.anel}.`;
            resumoLeitura.erros.push({ anel: anelInfo.anel, mensagem: errorMsg });
          }
        } catch (e) {
          console.error(`Falha ao requisitar planos para o Anel ${anelInfo.anel}:`, e);
          resumoLeitura.erros.push({
            anel: anelInfo.anel,
            mensagem: `Falha na comunicação ao buscar planos do Anel ${anelInfo.anel}.`,
          });
        }
      }

      if (resumoLeitura.lidos.length > 0) {
        const aneisLidos = resumoLeitura.lidos.join(', ');
        toastr.success(
          'Sucesso',
          `${todosOsPlanosColetados.length} plano(s) lido(s) com sucesso nos anéis: ${aneisLidos}.`,
        );
      }
      if (resumoLeitura.vazios.length > 0 && resumoLeitura.lidos.length === 0) {
        toastr.info('Atenção', `Nenhum plano configurado foi encontrado nos anéis: ${resumoLeitura.vazios.join(', ')}.`);
      }
      if (resumoLeitura.erros.length > 0) {
        const detalhes = resumoLeitura.erros.map(e => `Anel ${e.anel}: ${e.mensagem}`).join(' | ');
        toastr.error('Erro', detalhes);
      }
    } catch (error) {
      console.error('Falha geral ao ler anéis do controlador:', error);
      toastr.error('Erro', 'Não foi possível carregar a lista de anéis do controlador.');
    } finally {
      this.stopProcessing();
    }
  }

  async getPlano(cont, plano, anel, numCont, grupo) {
    return new Promise(resolve => {
      this.props
        .getListInterval(plano, anel, numCont, grupo)
        .then(result => {
          if (!result.error) {
            toastr.success('Sucesso', 'Plano ' + plano + ' lido com sucesso.');
            resolve(result.payload.data);
          } else {
            toastr.error('Erro', result.payload.response.data.errors[0]);
            resolve(false);
          }
        })
        .catch(e => {
          resolve(false);
          toastr.info('Atenção', 'Plano ' + plano + ' não encontrado!');
        });
    });
  }

  async limparPlano(data) {
    if (!this.state.salvarDB) {
      try {
        const resultTabelasTroca = await this.props.getTabelasTrocaPlano(data.id);
        const tabelasTroca = resultTabelasTroca.payload.data || [];

        if (tabelasTroca.length > 0) {
          const tabelasInfo = tabelasTroca.map(t => `${t.id} (${t.horario_inicial})`).join(', ');
          this.setState({
            confirmExclusao: {
              data,
              comTabelas: true,
              tabelasTroca,
              tabelasInfo,
            },
          });
        } else {
          this.setState({
            confirmExclusao: {
              data,
              comTabelas: false,
            },
          });
        }
      } catch (error) {
        console.error('Erro ao verificar tabelas de troca:', error);
        toastr.error('Erro', 'Falha ao verificar tabelas de troca vinculadas ao plano.');
      }
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido exclusão sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  async confirmarExclusaoPlano() {
    const { confirmExclusao } = this.state;
    if (!confirmExclusao) return;

    const { data, comTabelas, tabelasTroca } = confirmExclusao;
    this.setState({
      confirmExclusao: null,
      processingExclusao: true,
      processingExclusaoMessage: comTabelas
        ? 'Excluindo plano e tabelas de troca...'
        : 'Excluindo plano do sistema e controlador...',
    });

    try {
      if (comTabelas) {
        const idsTabelas = tabelasTroca.map(t => t.id);
        const resultExclusaoTabelas = await this.props.excluirTabelasTroca(idsTabelas);

        if (resultExclusaoTabelas.success) {
          await this.props.limpa(data);
        } else {
          toastr.error('Erro', 'Falha ao excluir tabelas de troca. O plano não foi excluído.');
        }
      } else {
        await this.props.limpa(data);
      }
    } catch (error) {
      console.error('Erro durante exclusão:', error);
      toastr.error('Erro', 'Falha durante o processo de exclusão.');
    } finally {
      this.setState({ processingExclusao: false, processingExclusaoMessage: '' });
    }
  }

  cancelarExclusaoPlano() {
    this.setState({ confirmExclusao: null });
  }

  alterarPlano(data) {
    if (!this.state.salvarDB) {
      this.props.showUpdate(data);
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido alteração sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  configurarPlano(data) {
    if (!this.state.salvarDB) {
      setTimeout(() => {
        if (this.props.permiteAlterarPagina) {
          this.props.permiteAlterarPagina(false);
        }

        window
          .$('#selectConfControlador')
          .val(data.controlador_id)
          .get(0)
          .dispatchEvent(new Event('change', { bubbles: true }));
        this.props.showIntervalo(data);

        if (this.props.permiteAlterarPagina) {
          this.props.permiteAlterarPagina(true);
        }
      }, 0);
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido configurar plano sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  render() {
    const planoDB = this.props.list;
    let plano = this.state.planoList;
    const paginaAtual = this.props.paginaAtual;
    const confirmExclusao = this.state.confirmExclusao;
    const confirmSalvarConfig = this.state.confirmSalvarConfig;
    const processingShow = this.state.processingExclusao || this.state.processingGeral;
    const processingMessage = this.state.processingExclusao
      ? this.state.processingExclusaoMessage
      : this.state.processingMessage;
    const processingDetail = this.state.processingExclusao
      ? 'Aguarde, esta operação pode levar alguns instantes.'
      : this.state.processingDetail;
    if (plano.length === 0) {
      plano = planoDB || [];
    }

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="plano-actions-cell">
            <PermissaoUsuario tela="CadPlano" condicao={true}>
              <div className="plano-actions-group">
                <SPButton
                  type="button"
                  className="success btn-sm"
                  icon="cog"
                  data-title="Configurar Plano"
                  onClick={() => this.configurarPlano(row.original)}
                />
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.alterarPlano(row.original)}
                />
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir e Limpar do Controlador"
                  onClick={() => this.limparPlano(row.original)}
                  disabled={row.original.id !== row.original.ultimo_plano}
                />
              </div>
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadPlano" condicao={false}>
              <div className="plano-actions-group">
                <SPButton
                  type="button"
                  className="success btn-sm"
                  icon="cog"
                  data-title="Configurar Plano"
                  onClick={() => this.configurarPlano(row.original)}
                />
                <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir e Limpar do Controlador"
                  disabled="disabled"
                />
              </div>
            </PermissaoUsuario>
          </div>
        ),
        width: 120,
        filterable: true,
        resizable: true,
        className: 'column_icon',
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Plano',
        accessor: 'id',
        width: 70,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Anel',
        accessor: 'anel',
        width: 70,
        className: 'column_grid column_center',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Descrição',
        accessor: 'descricao',
        width: 360,
        className: 'column_grid column_left',
        filterable: true,
        resizable: true,
      },
      {
        Header: 'Operação',
        className: 'column_grid column_left',
        accessor: 'modo_operacao_desc',
        width: 380,
        resizable: true,
      },
      {
        Header: 'Intervalos',
        accessor: 'numero_intervalo',
        className: 'column_grid column_center',
        width: 120,
        resizable: true,
      },
    ];

    return (
      <div ref={this.componentRef}>
        <ProcessingOverlay
          show={processingShow}
          message={
            processingMessage ? (
              <>
                {processingMessage}
                {processingDetail ? <small>{processingDetail}</small> : null}
              </>
            ) : (
              'Aguarde…'
            )
          }
          tagline="Planos do Controlador"
        />
        <ActionConfirmModal
          show={!!confirmSalvarConfig}
          title="Salvar as novas configurações?"
          message="Toda a configuração de planos para os anéis lidos será substituída. Esta ação não pode ser desfeita."
          itemName={
            confirmSalvarConfig
              ? `${confirmSalvarConfig.totalPlanos} plano(s) lido(s) do controlador`
              : ''
          }
          itemDetail={
            confirmSalvarConfig ? `${confirmSalvarConfig.totalAneis} anel(éis) serão sincronizados` : ''
          }
          confirmLabel="Sim, sincronizar"
          icon="save"
          onConfirm={this.confirmarSalvarPlanoDB}
          onCancel={this.cancelarSalvarPlanoDB}
        />
        <ActionConfirmModal
          show={!!confirmExclusao}
          title={
            confirmExclusao && confirmExclusao.comTabelas
              ? 'Plano possui Tabela de Troca vinculada'
              : 'Deseja realmente excluir do sistema e do controlador?'
          }
          message={
            confirmExclusao && confirmExclusao.comTabelas
              ? `Esse plano possui a(s) tabela(s) de troca ${confirmExclusao.tabelasInfo} vinculada(s) a ele. Esta exclusão removerá o plano e a(s) tabela(s) de troca. Deseja continuar?`
              : 'O plano será removido permanentemente do sistema e do controlador.'
          }
          itemName={
            confirmExclusao && confirmExclusao.data
              ? confirmExclusao.data.descricao || `Plano ${confirmExclusao.data.id}`
              : ''
          }
          itemDetail={
            confirmExclusao && confirmExclusao.data
              ? `Plano ${confirmExclusao.data.id}${confirmExclusao.data.anel ? ` · Anel ${confirmExclusao.data.anel}` : ''}`
              : ''
          }
          confirmLabel={confirmExclusao && confirmExclusao.comTabelas ? 'Sim, excluir tudo' : 'Excluir'}
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoPlano}
          onCancel={this.cancelarExclusaoPlano}
        />
        <style>{`
          .plano-actions-cell {
            display: flex;
            justify-content: center;
            width: 100%;
          }

          .plano-actions-group {
            display: inline-flex;
            align-items: center;
            gap: 4px;
            padding: 2px;
          }

          .plano-actions-group .btn {
            border-radius: 9px !important;
            min-width: 28px;
            width: 28px;
            height: 28px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            border: 0 !important;
            box-shadow: none !important;
            padding: 0 !important;
            font-size: 12px !important;
          }

          .plano-actions-group .btn.success {
            background: linear-gradient(135deg, #34d399 0%, #10b981 100%) !important;
            color: #ffffff !important;
          }

          .plano-actions-group .btn.warning {
            background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%) !important;
            color: #ffffff !important;
          }

          .plano-actions-group .btn.danger {
            background: linear-gradient(135deg, #f87171 0%, #ef4444 100%) !important;
            color: #ffffff !important;
          }

          .plano-footer-actions {
            display: flex;
            align-items: center;
            gap: 12px;
            flex-wrap: wrap;
            padding: 4px 2px 0;
          }

          .plano-footer-actions .btn {
            border-radius: 12px !important;
            min-height: 40px;
            padding: 0 16px !important;
            border: 0 !important;
            font-weight: 600;
            box-shadow: 0 10px 20px rgba(15, 23, 42, 0.08) !important;
          }

          .plano-footer-actions .btn.success {
            background: linear-gradient(135deg, #5fa8d3 0%, #3d8ec3 100%) !important;
            color: #ffffff !important;
          }
          .plano-footer-actions .btn.primary {
            background: linear-gradient(135deg, #4f8fb8 0%, #2f6f98 100%) !important;
            color: #ffffff !important;
          }

          .plano-premium-table .ReactTable .rt-th.column_left,
          .plano-premium-table .ReactTable .rt-td.column_left {
            justify-content: flex-start;
            text-align: left;
          }

          .plano-premium-table .ReactTable .rt-th.column_left .rt-resizable-header-content,
          .plano-premium-table .ReactTable .rt-th.column_left .rt-th-content {
            width: 100%;
            text-align: left;
            justify-content: flex-start;
          }

          .plano-premium-table .ReactTable .rt-th.column_center,
          .plano-premium-table .ReactTable .rt-td.column_center,
          .plano-premium-table .ReactTable .rt-th.column_icon,
          .plano-premium-table .ReactTable .rt-td.column_icon {
            justify-content: center;
            text-align: center;
          }
        `}</style>
        <div className="plano-premium-table">
          <PremiumTableShell summary={`${plano.length} plano(s) carregado(s)`} tableMinWidth={1120}>
            <ReactTableGT2A
              data={plano}
              columns={columns}
              showFilters={false}
              className="-striped -highlight"
              defaultPageSize={15}
              minRows={0}
              onPageChange={this.handlePageChange}
              page={paginaAtual}
            />
          </PremiumTableShell>
        </div>

        <div className="plano-footer-actions">
          <PermissaoUsuario tela="CadIntervaloPlano" campo="ler_controlador" condicao={true}>
            <ButtonTooltip
              type="button"
              id="btnLerControlador"
              className="success"
              icon="download"
              label="Ler Controlador"
              data-title="Busca os dados do controlador"
              onClick={this.lerPlanoControlador}
            />
          </PermissaoUsuario>

          <If condicao={this.state.salvarDB}>
            <PermissaoUsuario tela="CadPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataPlanoSalvarDB"
                className="primary"
                icon="check"
                label="Salvar no sistema"
                data-title="Salva no sistema os dados que vieram do controlador"
                onClick={this.salvarPlanoDB}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                id="btnDataPlanoSalvarDB"
                className="primary"
                icon="check"
                label="Salvar no sistema"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </If>
          <If condicao={this.state.salvarDB}>
            <PermissaoUsuario tela="CadPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnPlanoLerSistema"
                className="primary"
                icon="file-download"
                label="Ler do sistema"
                data-title="Busca os dados do banco de dados do sistema"
                onClick={this.lerPlanoSistema}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                id="btnPlanoLerSistema"
                className="primary"
                icon="file-download"
                label="Ler do sistema"
                disabled="disabled"
              />
            </PermissaoUsuario>
          </If>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.planoCad.list,
  aneis: state.controladorCad.aneis,
  paginaAtual: state.planoCad.paginaAtual,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showUpdate,
      limpa,
      showIntervalo,
      getList,
      getListInterval,
      getListTodosPlanosPorAnel,
      create,
      update,
      lerAneis,
      setPaginaAtual,
      sincronizarConfiguracaoCompleta,
      getTabelasTrocaPlano,
      excluirTabelasTroca,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PlanoList);
